export function EmailMacros (pEditor)
{
  this.queryOpenInsertEmailMacrosDialog = (pButton) =>
  {
    return !!pEditor.extParameters.macrosJson;
  };


  this.openInsertEmailMacrosDialog = (pButton) =>
  {
    pEditor.pDialog = pButton.getDialog();

    if (!pEditor.pDialog)
    {
      return false;
    }

    pEditor.range.save();

    let params =
      {
        macros: pEditor.extParameters.macros || pEditor.extParameters.macrosJson
      };

    let onSave = function (params)
    {
      pEditor.pThis.execCommand(pButton, 'insertEmailMacros', params);
    };

    let onCancel = function()
    {
      pEditor.afterCloseDialog();
    };

    window.BEditor.openDialog('openInsertEmailMacrosDialog', onSave, onCancel, params);

    pEditor.afterOpenDialog();
  };


  this.insertEmailMacros = (pButton, params) =>
  {
    let pParameters, sMacros;

    if (pEditor.pDialog)
    {
      if (params && params.macros)
      {
        pParameters = params;
      }
      else
      {
        pParameters = pEditor.pDialog.getReturnedParameters();
      }

      if (pParameters)
      {
        sMacros = pParameters.macros;
      }

      pEditor.closeDialog();

      if (sMacros)
      {
        pEditor.helpers.insertHTML(BEditor.utils.encodeHtml(sMacros.join(' ')));
      }
    }
  };
}